module.exports = __webpack_public_path__ + "static/img/welfare.5f7bce64.png";